import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';



const preferredLanguage = localStorage.getItem('i18nextLng') || 'english';

i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
        lng: preferredLanguage,
        fallbackLng: 'en',
        backend: {
            loadPath: '/locates/{{lng}}.json',
        },
    });

export default i18n;
